export default "__VITE_ASSET__RI0RzaTY__"